<div class="h-full w-full flex items-center justify-center">
  <div class="w-[253px] h-[165px] flex items-center justify-center flex-col">
    <h2 class="content-regular text-foreground-75 leading-[24px]">{{ errorTitle() | translate }}</h2>
    <span class="content-sm-regular text-muted-foreground leading-[20px]">{{ subtitle() | translate }}</span>
    <lib-button [type]="'secondary'" (click)="retry.emit()" class="pt-[8px]">
      <div class="flex justify-center items-center">
        <span class="px-[5px]">{{ buttonLabel() | translate }}</span><i class="fi fi-rr-rotate-left text-[20px] text-muted-foreground leading-[0]"></i>
      </div>
    </lib-button>
  </div>
</div>
